<template>
  <EmdFormGroup
    :label="$t('company-name')"
    required
    :state="getState($v.recipient.company_name)"
    :feedbacks="feedbacks($v.recipient.company_name)"
  >
    <EmdInput
      @input="() => $v.recipient.company_name.$touch()"
      v-model="recipient.company_name"
      name="company_name"
      :readonly="disabled"
      :disabled="disabled"
      v-if="canEdit"
    />
    <span v-else>{{ recipient.company_name }}</span>
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { corporationUser } from '../validations'
export default {
  name: 'CompanyNameInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    company_name: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  validations () {
    return { recipient: corporationUser }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "company-name": "Nome da empresa"
      },
    "en-US": {
      "company-name": "Company Name"
    }
  }
</i18n>
